import { DataV2API } from "../Endpoints";

class Pharmacy {
    get() {
        return DataV2API.get("/pharmacies");
    }

    add(pharmacy) {
        return DataV2API.post("/pharmacies", pharmacy);
    }

    update(pharmacy) {
        return DataV2API.post("/pharmacy/" + pharmacy.id, pharmacy);
    }

    delete(pharmacy) {
        return DataV2API.delete("/pharmacy/" + pharmacy.id, pharmacy);
    }
}

export default new Pharmacy();
